import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { observer } from "mobx-react";
import { toJS } from 'mobx'
import { useTranslation, Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Badge from 'react-bootstrap/Badge';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import TimesheetItem from './timesheet-item';
import TimesheetHeaderItem from './timesheetheaderitem';
import ListGroup from 'react-bootstrap/ListGroup';
import Skeleton from 'react-loading-skeleton'

import FormSelect from './../inputs/select';

import { getFullName, formatMonthYear, getFromLocalStorage, setLocalStorage, formatMonthYearNum, getAvailableMonths2, sort, getConfig, getTimesheetActivityFilter } from './../../utils';

import { publish, subscribe } from "./../../events";
import FormText from './../inputs/text';

const TimesheetList = () => {


    let navigate = useNavigate();
    const { usersAdminStore, loginStore, activitiesStore, timesheetStore, utilsStore, templatesStore } = useStores();
    const { getDummy, users, user, dummies } = usersAdminStore;
    const { getUserActivities, userActivities } = activitiesStore;
    const { send } = templatesStore;
    const { getDevsMonths, months, getAvailableMonths, available, getDevelopers, developers, getDevsMonthsFilteredByActivity } = timesheetStore;
    const { getTemplatesWithoutEventType, templatesWithoutEventType } = utilsStore;
    const { saveHours } = timesheetStore;
    const { t, i18n } = useTranslation();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [isLoading, setIsLoading] = useState(false);
    const { accountInfo } = loginStore;
    const [client, setClient] = useState(null);
    const [consultant, setConsultant] = useState(-1);
    const devTimesheet = useRef(null)
    const [validated, setValidated] = useState(false);
    const [dev, setDev] = useState(-1);
    const [activity, setActivity] = useState(getFromLocalStorage(`${accountInfo.name}_timesheetList_activity`, -1));
    const [project, setProject] = useState(-1);
    const [month, setMonth] = useState(getFromLocalStorage(`${accountInfo.name}_timesheetList_month`, formatMonthYearNum(new Date())));
    const [hideFinished, setHideFinished] = useState(getFromLocalStorage("timesheetList_billed", false));
    const [ignoreIds, setIgnoreIds] = useState([]);

    useEffect(() => {
        subscribe("notificationIgnored", (n) => {
            if (n?.detail?.serializedData) {
                var data = JSON.parse(n.detail.serializedData);
                if (data.reason === "notificationMessageSent") {
                    ignoreIds.push(data.userId);
                    setIgnoreIds([...ignoreIds]);
                }
            }
        });

        loadActivities()
            .then(() => {
                refreshActivities(dev, month, activity);
            });
    }, [null]);

    const getDevs = () => {
        var options = developers?.map(x => { return { id: x.id, name: x.username?.toUpperCase() } })?.sort((a, b) => a.name.localeCompare(b.name)) ?? [];
        options.unshift({ id: -1, name: t("all") })
        return options;
    }

    const getMonths = () => {
        return available?.map((x) => { return { id: `${x.month}_${x.year}`, name: formatMonthYear(new Date(x.year, x.month - 1, 1)) } });
    }

    const getProjects = () => {
        var options = [...new Map(months?.flatMap(a => a.project)?.map(item => [item["id"], item])).values()];
        options.unshift({ id: -1, name: t("all") })
        return options;
    }

    const loadActivities = () => {
        setIsLoading(true);
        return Promise.all([1].indexOf(accountInfo.role) > -1 ? [getDevsMonths(dev, month), getTemplatesWithoutEventType(), getAvailableMonths(), getDevelopers()] : [getUserActivities()]).then(() => setIsLoading(false));
    }

    const refreshActivities = (dev, month, activity) => {
        setIsLoading(true);
        getDevsMonthsFilteredByActivity(dev, month, activity).then(() => setIsLoading(false));
    }

    const getInitialDate = () => {
        
        if (accountInfo.role == 3) {
            var savedInitial = getConfig("date", `current_${accountInfo.name}`);
            if (savedInitial) {
                return new Date(savedInitial);
            }
            else {
                return new Date();
            }
        }
        else if (accountInfo.role == 2) {

            var activities = userActivities
                .flatMap(activity => activity.months)
                .filter(activity => activity.status == 1)
                .sort((activityA, activityB) => activityA.year - activityB.year || activityA.month - activityB.month);

            if (!!activities.length) {
                var year = activities[0].year;
                var month = activities[0].month;
                console.log(year);
                console.log(month);
                return new Date(year, month - 1, 1);
            } else {
                return new Date();
            }
        } else {
            return new Date();
        }
    }

    const isFinished = (month) => month?.devMonthStatus?.finished ?? false;
    const devExistsInFilter = () => getDevs()?.map(x => x.id)?.includes(Number(dev));

    const getFiltered = () => {
        if (getDevs()?.length > 1 && !devExistsInFilter())
            setDev(-1);

        var list = months?.filter(x => x.monthYear == month) ?? [];
        if (dev > -1) { list = list.filter(x => x.developer.id == dev); }
        if (project > -1) { list = list.filter(x => x.project.id == project); }
        if (hideFinished) { list = list?.filter(x => !isFinished(x)); }

        return sort("developer.username", list);
    }

    const [showTemplate, setShowTemplate] = useState(false);
    const [templateValidated, setTemplateValidated] = useState(false);
    const [monthForMessage, setMonthForMessage] = useState(null);

    const handleTemplate = (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            const formData = Object.fromEntries(new FormData(event.target).entries());

            send(formData).then(() => {
                setShowTemplate(false)
            });

        }
        setTemplateValidated(true);
    }
    return (
        <Stack gap={2}>
            <Modal show={showTemplate} onHide={() => { setShowTemplate(false); /*setMailConfValidated(false)*/ }}>
                <Form noValidate validated={templateValidated} onSubmit={handleTemplate}>
                    <Modal.Header closeButton>
                        <Modal.Title>{t("sendMessage")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Stack gap={2}>
                            <FormText hidden id="id" object={{ id: `${monthForMessage?.developer?.id}_${monthForMessage?.month}_${monthForMessage?.year}` }} />
                            <FormSelect required hideNone label={t("template")} id="templateId" isLoading={isLoading} items={templatesWithoutEventType?.map((x) => ({ id: x.id, name: x.name }))} itemId="id" itemLabel="name" />
                            <br />
                        </Stack>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" type="submit">
                            {t("send")}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>


            {accountInfo.role == 1 && <Card>
                <Card.Body>
                    <div>
                        <Row>
                            <Col xs={3}>
                                <Stack direction="vertical" >

                                    {isLoading ? <Skeleton /> : <b>{t('activity')}:</b>}
                                    <FormSelect required hideNone value={activity} useVal isLoading={isLoading} items={getTimesheetActivityFilter()} itemId="id" itemLabel="name" onChange={(a) => {
                                        refreshActivities(dev, month, a);
                                        setLocalStorage(`${accountInfo.name}_timesheetList_activity`, a);
                                        setActivity(a);
                                    }} />
                                </Stack>
                            </Col>
                            <Col xs={3}>
                                <Stack direction="vertical">

                                    {isLoading ? <Skeleton /> : <b>{t('date')}:</b>}
                                    {isLoading ? <Skeleton height={30} /> : <FormSelect required hideNone value={month} useVal isLoading={isLoading} items={getMonths()} itemId="id" itemLabel="name" onChange={(m) => {
                                        refreshActivities(dev, m, activity);
                                        setLocalStorage(`${accountInfo.name}_timesheetList_month`, m);
                                        setMonth(m);
                                    }} />}
                                </Stack>
                            </Col>

                            {<Col xs={3}>
                                <Stack direction="vertical" style={{ height: "100%" }}>
                                    {isLoading ? <Skeleton /> : <b>{t('filterStatus')}:</b>}
                                    {isLoading ? <Skeleton height={30} /> : <Form.Check type="checkbox" id="billed" label={t("hideFinished")} className="my-auto" onChange={(v) => {
                                        setLocalStorage("timesheetList_billed", v.target.checked);
                                        setHideFinished(v.target.checked);
                                    }} checked={hideFinished ?? false} />}
                                </Stack>
                            </Col>}

                        </Row>
                    </div>
                </Card.Body>
            </Card>}

            {accountInfo.role == 1 && <Card>
                <Card.Body>
                    <div className="p-2">



                        <Stack gap={1}>

                            {(!isLoading && getFiltered()?.length > 0) &&
                                <Row>
                                    <Col>{isLoading ? <Skeleton /> : <span>{t("consultantInfo")}:</span>}</Col>
                                    <Col>{isLoading ? <Skeleton /> : <span>{t("activities")}:</span>}</Col>

                                    <Col>{isLoading ? <Skeleton /> : <span>{t("workflow")}:</span>}</Col>
                                    <Col>{isLoading ? <Skeleton /> : <span>{t("information")}:</span>}</Col>
                                    <Col><span></span></Col>
                                </Row>}

                            {(!isLoading && !getFiltered()?.length) &&
                                <Row>
                                    <span>{t("noItemsFound")}</span>
                                </Row>}

                            {(isLoading || !dummies) &&
                                Array.from({
                                    length: 5
                                }).map((_, index) => (
                                    <Skeleton key={index} height={100} />)
                                )}

                            {!isLoading && getFiltered()?.map((m, index) => (

                                <TimesheetHeaderItem onMessage={() => {
                                    setMonthForMessage(m);
                                    setShowTemplate(true)
                                }} key={index} ignoreMessage={ignoreIds?.indexOf(m.developer?.id) > -1 ?? false} id={index} month={m} onUpdateUser={(u) => {
                                    months?.forEach(m => {
                                        if (m.developer?.id == u?.id)
                                            m.developer.information = u.data;
                                    })
                                }} />

                            ))}
                        </Stack>
                    </div>






                </Card.Body>
            </Card >}


            {/*MODIFICAR ESTO PARA QUE USE PROPS.ITEMS SIEMPRE*/}

            {/*Client*/}
            {(accountInfo.role == 2 /*&& consultant > -1*/) &&
                <TimesheetItem role={accountInfo?.role}/* activities={activities} */ users={dummies} /*isLoading={isLoading}*/ state={1} noUpload={true} items={userActivities} initialDate={getInitialDate()} isLoading={isLoading} afterSave={() => loadActivities()} />
            }

            {/*Dev*/}
            {(accountInfo.role == 3/* && client*/)
                && <TimesheetItem role={accountInfo?.role} /*activities={activities}*/ users={dummies} /*isLoading={isLoading}*/ state={0} editable={true} ref={devTimesheet} items={userActivities} initialDate={getInitialDate()} isLoading={isLoading} afterSave={() => loadActivities()} />
            }


        </Stack>
    );
};

export default observer(TimesheetList);
